import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AppComponent } from '../app.component';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private app: AppComponent) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this.app.isLoading = true;
    return next.handle(req).pipe(finalize(() => (this.app.isLoading = false)));
  }
}
